import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { IFilterCategoryGroup } from '../../models/i-filter-category-group';
import { ngHelper, UiContextService } from '@cakeiteasy/web-utils';


@Component({
  standalone: false,
  selector: 'category-groups-selector',
  templateUrl: './category-groups-selector.component.html',
  styleUrls: ['./category-groups-selector.component.scss']
})
export class CategoryGroupsSelectorComponent implements OnChanges {
  @Input() groups: IFilterCategoryGroup[];
  @Input() activeGroupId: number;
  @Output() onSelect = new EventEmitter<IFilterCategoryGroup>();
  @Input() maxGroupsToShow: number = 6;

  public linkGroups: IFilterCategoryGroup[];
  public dropdownGroups: IFilterCategoryGroup[];
  public selectedDropdownGroup: IFilterCategoryGroup;

  constructor(private _uiContext: UiContextService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    ngHelper.ifChanged(changes, 'groups', (groups) => {
      this._initDropdownGroups(groups);

      if (this.selectedDropdownGroup) {
        this._updateSelectedDropdownGroup(this.selectedDropdownGroup);
      }
    });
  }

  public selectGroup(group: IFilterCategoryGroup) {
    this.selectedDropdownGroup = null;
    this.onSelect.emit(group);
    this.activeGroupId = group ? group.id : null;
  }

  public dropdownSelectCategory(group: IFilterCategoryGroup) {
    this.selectedDropdownGroup = group;
    this.onSelect.emit(group);
    this.activeGroupId = group ? group.id : null;
  }

  private _initDropdownGroups(groups) {
    if (this._uiContext.isXs()) {
      this.linkGroups = groups;
      this.dropdownGroups = [];
    } else {
      // so we add +1 as we assume that dropwdown also eat one place
      if (groups.length > (this.maxGroupsToShow + 1)) {
        this.linkGroups = groups.slice(0, this.maxGroupsToShow);
        this.dropdownGroups = groups.slice(this.maxGroupsToShow, this.groups.length);
      } else {
        this.linkGroups = groups;
        this.dropdownGroups = [];
      }
    }

    if (this.dropdownGroups.length && this.activeGroupId) {
      this.selectedDropdownGroup = this.dropdownGroups.find((c) => c.id === this.activeGroupId) || null;
    }
  }

  private _updateSelectedDropdownGroup(group: IFilterCategoryGroup) {
    this.selectedDropdownGroup = this.dropdownGroups
        .find((c) => c.id === group.id) ||
      this.dropdownGroups[0];
  }
}
